import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import breakIcon from './break.svg';
import resestIcon from './reset.svg';
import bindAll from 'lodash.bindall';
import styles from '../gui/gui.css';
import {connect} from 'react-redux';
import {setGuiTovm} from '../../reducers/code';
import VM from 'scratch-vm';

const btnGroupStyle = {
    display: 'flex',
    WebkitBoxOrient: 'horizontal',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'row',
    msFlexDirection: 'row',
    flexDirection: 'row',
    position: 'absolute',
    right: 0
};
const btnTextStyle = {marginLeft: '-5px'};

class ResultBox extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleExtensionAdded',
            'breakHandler',
            'resetHandler',
        ]);
        this.state = {
            scrollHeight: 0,
            isHandpy: false
        };
    }
    componentDidMount () {
        this.handleExtensionAdded();
        this.props.vm.addListener('EXTENSION_ADDED', this.handleExtensionAdded);
    }
    componentWillUnmount () {}
    handleExtensionAdded () {
        const blockInfo = this.props.vm.runtime._blockInfo;
        let isHandpy = false;
        for (let i = 0; i < blockInfo.length; i++) {
            const el = blockInfo[i];
            if (el.id == 'handpy') {
                isHandpy = true;
                break;
            }
        }
        this.setState({isHandpy});
    }
    handleScrollHeightChange () {
        if (!this.resizeBox) {
            return false;
        }
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            const {scrollHeight, clientHeight} = this.resizeBox;
            if (scrollHeight != this.state.scrollHeight) {
                this.setState({scrollHeight});
                this.resizeBox.scrollTop = scrollHeight - clientHeight;
            }
            this.timer = null;
        }, 300);
    }
    breakHandler () {
        const {code, guiTovm, setGuiTovm} = this.props;
        setGuiTovm({
            state: !guiTovm.state,
            method: 'breakOff',
            data: code
        })
    }
    resetHandler () {
        const {code, guiTovm, setGuiTovm} = this.props;
        setGuiTovm({
            state: !guiTovm.state,
            method: 'reset',
            data: code
        })
    }
    render () {
        const {burnResult} = this.props;
        const {isHandpy} = this.state;
        this.handleScrollHeightChange();
        return (
            <React.Fragment>
                <Box className={styles.codeHeaderWrapper}>
                    上传日志
                    {isHandpy && (
                        <div style={{...btnGroupStyle}}>
                            <Button
                                iconSrc={breakIcon}
                                onClick={this.breakHandler}
                            >
                                {/* this.runcode('') */}
                                <span style={{...btnTextStyle}}>中断</span>
                            </Button>
                            <Button
                                iconSrc={resestIcon}
                                onClick={this.resetHandler}
                            >
                                {/* this.runcode('import machine;machine.reset()\r\n'); */}
                                <span style={{...btnTextStyle}}>重置</span>
                            </Button>
                        </div>
                    )}
                </Box>
                <Box
                    className={styles.codeBurnLogWrapper}
                    componentRef={el => this.resizeBox = el}
                >
                    {burnResult.status}
                    {burnResult.message}
                </Box>
            </React.Fragment>
        );
    }
}

ResultBox.propTypes = {
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm,
    burnResult: state.scratchGui.code.burnResult,
    guiTovm: state.scratchGui.code.guiTovm,
});

const mapDispatchToProps = dispatch => ({
    setGuiTovm: (guiTovm) => {
        dispatch(setGuiTovm(guiTovm))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultBox);
